const newStory = {
  info: {
    name: "",
    colour: "red",
  },
  cards: {},
};

const newStartCard = {
  description: "Start",
  tags: "",
  paragraphs: [],
  nodeType: "start",
  links: [
    {
      target: "start",
      linkText: "na",
      conditions: [],
      actions: [],
    },
  ],
  editor: {
    left: 100,
    top: 200,
  },
};

const newEndCard = {
  description: "End",
  tags: "",
  paragraphs: [],
  nodeType: "end",
  prevStory: "",
  detourId: "",
  links: [
    {
      target: "end",
      linkText: "na",
      conditions: [],
      actions: [],
    },
  ],
  editor: {
    left: 700,
    top: 200,
  },
};

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
    (
      c ^
      (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
    ).toString(16)
  );
}
/*
function addStart(story) {
  let id = "start";
  props.data.stories[story].cards[id] = JSON.parse(
    JSON.stringify(newStartCard)
  );
}

function addEnd(story) {
  let id = "end";
  props.data.stories[story].cards[id] = JSON.parse(JSON.stringify(newEndCard));
}
*/

function addTextKey(storyData) {
  let id = uuidv4();
  storyData.loc[id] = {};

  const keys = Object.keys(storyData.loc["na"]);
  keys.forEach((key, index) => {
    storyData.loc[id][key] = "...";
  });
  return id;
}

export function addStory(name, storyData) {
  let id = uuidv4();
  storyData.stories[id] = JSON.parse(JSON.stringify(newStory));

  let textKey = addTextKey(storyData);
  storyData.stories[id].info.name = textKey;

  storyData.loc[textKey]["en"] = name;

  //  props.edit.currentStory = id;

  // Add start card
  let startId = "start";
  storyData.stories[id].cards[startId] = JSON.parse(
    JSON.stringify(newStartCard)
  );

  // Add end card
  let endId = "end";
  storyData.stories[id].cards[endId] = JSON.parse(JSON.stringify(newEndCard));

  //  addStart(id);
  //  addEnd(id);
  //
  //

  //  console.log(storyData.loc[textKey]);
  //console.log(storyData.stories[id]);

  return id;
}
